import { motion } from "framer-motion";
import {
  UserCheck, UtensilsCrossed, Dumbbell, Plane, BookOpen, ClipboardList, HandHeart, Sprout,
} from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { BENEFITS } from "@/data/content";

const ICONS = { UserCheck, UtensilsCrossed, Dumbbell, Plane, BookOpen, ClipboardList, HandHeart, Sprout };

export default function WhatYouGet() {
  return (
    <section id="what-you-get" className="py-24 sm:py-32 bg-cardbg" data-testid="what-you-get-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          eyebrow="What Clients Receive"
          title="More Than a Diet Plan. A Personalised Health System."
          sub="Every Aarogyam Bharat pathway includes a complete coaching experience — designed around you."
        />
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {BENEFITS.map((b, i) => {
            const Icon = ICONS[b.icon];
            return (
              <Reveal key={b.title} delay={i * 0.06}>
                <motion.div
                  whileHover={{ y: -8 }}
                  transition={{ duration: 0.35 }}
                  className="h-full bg-ivory border border-botanical/10 rounded-3xl p-7 shadow-card hover:shadow-hover transition-shadow duration-300"
                  data-testid={`benefit-card-${i}`}
                >
                  <div className="w-12 h-12 rounded-full bg-forest flex items-center justify-center mb-5">
                    <Icon size={20} className="text-gold" />
                  </div>
                  <h3 className="font-serif text-xl text-forest leading-snug">{b.title}</h3>
                  <p className="mt-2.5 text-sm leading-relaxed text-inkmuted">{b.text}</p>
                </motion.div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
